/* ATN CyberMall — Section 04 Sample Showroom: functional tab switching */
(function () {
  function initSamp(root) {
    if (!root || root.__sampInit) return;
    root.__sampInit = true;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-samp-tab]'));
    var panes = Array.prototype.slice.call(root.querySelectorAll('[data-samp-panel]'));
    if (!tabs.length) return;

    function activate(idx, focusTab) {
      idx = String(idx);
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-samp-tab') === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focusTab) t.focus();
      });
      panes.forEach(function (p) {
        var on = p.getAttribute('data-samp-panel') === idx;
        if (on) { p.removeAttribute('hidden'); }
        else { p.setAttribute('hidden', ''); }
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        activate(t.getAttribute('data-samp-tab'), false);
      });
      t.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(t);
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          var n = tabs[(i + 1) % tabs.length];
          activate(n.getAttribute('data-samp-tab'), true);
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var pv = tabs[(i - 1 + tabs.length) % tabs.length];
          activate(pv.getAttribute('data-samp-tab'), true);
        } else if (e.key === 'Home') {
          e.preventDefault();
          activate(tabs[0].getAttribute('data-samp-tab'), true);
        } else if (e.key === 'End') {
          e.preventDefault();
          activate(tabs[tabs.length - 1].getAttribute('data-samp-tab'), true);
        }
      });
    });

    var initEl = tabs.filter(function (t) {
      return t.getAttribute('aria-selected') === 'true';
    })[0] || tabs[0];
    activate(initEl.getAttribute('data-samp-tab'), false);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-samp-root]');
    for (var i = 0; i < roots.length; i++) initSamp(roots[i]);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-samp-root]');
    if (r) { r.__sampInit = false; initSamp(r); }
  });
})();